import { useState } from 'react';
import type { GuestCommunicationChannel, GuestCommunicationMessageKey } from '@/shared/api';
import type { FieldKey, Issue, Lang } from './editorModel';

export type Pane = 'edit' | 'preview';

/** Was im Nachrichtenbereich gerade gewählt ist — Anlass, Kanal, Sprachen, Ansicht und Sprungziel. */
export function useMessagesView() {
  const [selected, setSelected] = useState<GuestCommunicationMessageKey>('Welcome');
  const [channel, setChannel] = useState<GuestCommunicationChannel>('Email');
  const [lang, setLang] = useState<Lang>('De');
  const [guestLang, setGuestLang] = useState<Lang>('De');
  const [focus, setFocus] = useState<{ field: FieldKey; request: number } | null>(null);
  // Erst ein Speicherversuch macht aus Hinweisen an den Feldern einen Grund in der Leiste.
  const [attempted, setAttempted] = useState(false);
  const [phoneEditorOpen, setPhoneEditorOpen] = useState(false);
  // Schmal zeigt nur eine der beiden Ansichten; ein Sprung zum Feld braucht den Text.
  const [pane, setPane] = useState<Pane>('edit');

  return {
    selected,
    setSelected,
    channel,
    setChannel,
    lang,
    setLang,
    guestLang,
    setGuestLang,
    focus,
    /** Ein Sprung wirkt einmal — danach fokussiert kein Wechsel das Feld erneut. */
    clearFocus: () => setFocus(null),
    pane,
    setPane,
    attempted,
    setAttempted,
    phoneEditorOpen,
    setPhoneEditorOpen,
    jumpTo: (issue: Issue) => {
      setSelected(issue.key);
      setChannel(issue.channel);
      setLang(issue.lang);
      setPane('edit');
      setFocus({ field: issue.field.key, request: Date.now() });
    },
  };
}
